import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { LogoCont, ChildrenCont, LogoIcon } from './LogoOutlet.styles';

const LogoOutlet: FC = () => {
  return (
    <LogoCont>
      <ChildrenCont>
        <LogoIcon />
        <Outlet />
      </ChildrenCont>
    </LogoCont>
  );
};

export default LogoOutlet;
